<template>
  <div class="flex items-baseline">
    <div class="flex-1 px-4">
      <RouterLink
        :to="{
          name: 'accounts.contactLists.contactListUuid',
          params: {
            ...$route.params,
            contactListUuid: contactList.id,
          },
        }"
      >
        {{ contactList.name }}
      </RouterLink>
    </div>
    <div class="px-4">
      {{ contactList.activeSubscriptionsCount || 0 }}
    </div>
    <div class="px-4">
      <VDropdown v-if="$membershipHasPermissionTo('edit contact lists,delete contact lists')" right>
        <template #button="dropdownProps">
          <button class="btn btn-ghost px-3" @click="dropdownProps.open">
            <FontAwesomeIcon icon="ellipsis-v" fixed-width />
          </button>
        </template>

        <template #default="dropdownProps">
          <VDropdownMenu>
            <a
              v-if="$membershipHasPermissionTo('edit contact lists')"
              role="button"
              :class="[
                'block',
                'px-4',
                'py-2',
                'hover:bg-gray-200',
                'transition-color',
                'transition-fast',
                'text-right',
              ]"
              @click="dropdownProps.close(() => $emit('contact-list-edit', contactList))"
              >Edit</a
            >
            <a
              v-if="$membershipHasPermissionTo('delete contact lists')"
              role="button"
              :class="[
                'block',
                'px-4',
                'py-2',
                'hover:bg-gray-200',
                'transition-color',
                'transition-fast',
                'text-right',
              ]"
              @click="dropdownProps.close(() => $emit('contact-list-delete', contactList))"
              >Remove</a
            >
          </VDropdownMenu>
        </template>
      </VDropdown>
    </div>
  </div>
</template>

<script>
import VDropdown from '@/components/Common/VDropdown.vue';
import VDropdownMenu from '@/components/Common/VDropdownMenu.vue';

export default {
  components: {
    VDropdown,
    VDropdownMenu,
  },

  props: {
    contactList: { type: Object, required: true },
  },
};
</script>
